/**
 * Formatos y tamaño máximo de las imágenes que se suben desde el BO (PNG, JPG o WebP, hasta 5 MB).
 * Misma regla que hoy repiten BenefitForm, BenefitPartnerForm y BenefitImagesManager.
 */
export const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const IMAGE_FILE_ACCEPT = ALLOWED_IMAGE_TYPES.join(",");
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/** Null si el archivo sirve; si no, el mensaje para el usuario. */
export const validateImageFile = (file: File): string | null => {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return "Formato de imagen no soportado. Usá PNG, JPG o WebP.";
  }
  if (file.size > MAX_IMAGE_BYTES) {
    return "La imagen supera el máximo de 5 MB.";
  }
  return null;
};
